export default __webpack_public_path__ + "static/media/icon_domain-dns_hover.641b53b1.svg";